export const environment = {
  production: true,
  NG_APP_GIPHY_TOKEN: 'sbNfzaiqsMkU7T8pYD7quZZAq0m3OAyd',
  mapbox: {
    accessToken: 'pk.eyJ1IjoianVtcGhpcmUiLCJhIjoiY2syMjZyYjA0MW54MDNncDQyeWZqNnlycSJ9.h3k-S0uC7JJxJGTUpzFfbw'
  }   
};
